import copyToClipboard from 'copy-to-clipboard';

import '../MarkdownEditor/styles/editor.css';

import 'fomantic-ui-less/definitions/modules/calendar.less';

import 'fomantic-ui-less/definitions/modules/modal';
import 'fomantic-ui-less/definitions/modules/dimmer';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/accordion';
import 'fomantic-ui-less/definitions/modules/popup';
import 'fomantic-ui-less/definitions/modules/calendar';
import 'fomantic-ui-less/definitions/behaviors/form';

import {imageWrapper} from '../Common/imageWrapper';

import CheckBoldSvg from '@mdi/svg/svg/check-bold.svg';
import ContentCopySvg from '@mdi/svg/svg/content-copy.svg';
import ArrowUpSvg from '@mdi/svg/svg/arrow-up.svg';
import ArrowDownSvg from '@mdi/svg/svg/arrow-down.svg';

import MarkdownEditor from '../MarkdownEditor';
import {friendlyBytes} from '../MarkdownEditor/helper/file';
import {api} from '../Common/fetchWithTimeout';
import isEmpty from 'lodash/isEmpty';
import {parseJSON, stringifyJSON} from '../Common/json';
import {decode} from 'html-entities';
import {createLogger} from '../Common/logger';
import {setupDropdowns} from '../Common/dropdowns';
import {filterFields} from '../Common/formFields';
import debounce from 'lodash/debounce';
import {Sortable} from 'sortablejs';

const LOGGER = createLogger("PageView");

const currentPageId = document.querySelector('meta[name="swf-page-id"]')?.getAttribute('content') || '';

const handleCopyCode = copyCodeLink => {
    let linkDisabled;
    if (linkDisabled) {
        return false;
    }

    copyCodeLink.innerHTML = `<img class="icon-12 ui icon" src="${CheckBoldSvg}" alt=""> Copied to clipboard`;
    linkDisabled = true;
    setTimeout(() => {
        copyCodeLink.innerHTML = `<img class="icon-12 ui icon" src="${ContentCopySvg}" alt=""> Copy`;
        linkDisabled = false;
    }, 1250);

    return true;
};

const createCodeCopy = () => {
    const copyCodeLink = document.createElement('a');
    copyCodeLink.className = 'right aligned floating ui label basic';
    copyCodeLink.innerHTML = `<img class="icon-12 ui icon" src="${ContentCopySvg}" alt=""> Copy`;
    copyCodeLink.addEventListener('click', event => {
        event.stopPropagation();
        event.preventDefault();

        if (!handleCopyCode(copyCodeLink)) {
            return;
        }

        copyToClipboard(
            copyCodeLink.parentElement.querySelector('pre code').textContent.trim(),
            {
                format: 'text/plain',
            });

        copyCodeLink.focus();
    });
    return copyCodeLink;
};

const createEditor = richTextTextArea => {
    const containerFragment = document.createDocumentFragment();
    const height = richTextTextArea.getBoundingClientRect().height;

    const editor = document.createElement('div');
    editor.className = 'ui segments';

    let view;

    const editorContainer = document.createElement('div');
    editorContainer.className = 'ui segment text-editor';

    const currentUrl = new URL(window.location.href);
    const fileUploadUrl = `${currentUrl.pathname}/attachments`;

    const clonedRichTextTextArea = richTextTextArea.cloneNode();
    clonedRichTextTextArea.style.display = 'none';
    clonedRichTextTextArea.addEventListener('refresh-rich-text', () => {
        view && view.destroy();
        view = new MarkdownEditor({
            target: editorContainer,
            doc: clonedRichTextTextArea.value,
            editable: !clonedRichTextTextArea.readOnly,
            fileUploadUrl,
            onEditorBlur: markdown => clonedRichTextTextArea.value = markdown,
        });
        view.height = height;
    });

    editorContainer.appendChild(clonedRichTextTextArea);

    view = new MarkdownEditor({
        target: editorContainer,
        doc: richTextTextArea.value,
        editable: !richTextTextArea.readOnly,
        fileUploadUrl,
        onEditorBlur: markdown => clonedRichTextTextArea.value = markdown,
    });
    view.height = height;

    editor.appendChild(editorContainer);

    if (!richTextTextArea.readOnly) {
        const editorSwitch = document.createElement('div');
        editorSwitch.className = 'ui secondary segment';

        const switchToggle = document.createElement('div');
        switchToggle.className = 'ui compact tiny basic buttons';

        const visualButton = document.createElement('button');
        visualButton.id = `${richTextTextArea.id}Visual`;
        visualButton.className = 'ui button active';
        visualButton.innerText = 'Visual';
        visualButton.addEventListener('click', e => {
            e.preventDefault();

            if (e.target.classList.contains('active')) {
                return;
            }

            e.target.classList.add('active');
            document.getElementById(`${richTextTextArea.id}Markdown`).classList.remove('active');

            const targetTextArea = document.getElementById(richTextTextArea.id);
            view && view.destroy();
            view = new MarkdownEditor({
                target: editorContainer,
                doc: targetTextArea.value,
                editable: !targetTextArea.readOnly,
                fileUploadUrl,
                onEditorBlur: markdown => targetTextArea.value = markdown,
            });
            view.height = targetTextArea.getBoundingClientRect().height;
            targetTextArea.style.display = 'none';
        });

        const markdownButton = document.createElement('button');
        markdownButton.id = `${richTextTextArea.id}Markdown`;
        markdownButton.className = 'ui button';
        markdownButton.innerText = 'Markdown';
        markdownButton.addEventListener('click', e => {
            e.preventDefault();

            if (e.target.classList.contains('active')) {
                return;
            }

            e.target.classList.add('active');
            document.getElementById(`${richTextTextArea.id}Visual`).classList.remove('active');

            const targetTextArea = document.getElementById(richTextTextArea.id);
            targetTextArea.style.height = `${editorContainer.getBoundingClientRect().height -
            32}px`;
            targetTextArea.style.display = 'block';
            targetTextArea.focus();
            view && view.destroy();
        });

        switchToggle.appendChild(visualButton);
        switchToggle.appendChild(markdownButton);
        editorSwitch.appendChild(switchToggle);
        editor.appendChild(editorSwitch);
    }

    containerFragment.appendChild(editor);

    return containerFragment;
};

const updateTask = debounce(($form, row) => {
    if (!$form.form('is valid')) {
        return;
    }

    const workflowId = row.getAttribute('data-workflow-id');
    const taskId = row.getAttribute('data-task-id');
    const filteredOutput = filterFields($form.form('get values'));
    if (!isEmpty(filteredOutput)) {
        api(`/api/workflows/${workflowId}/tasks/${taskId}/output`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: stringifyJSON(filteredOutput),
        }).catch(error => LOGGER.error('Unable to save task', {workflowId, taskId, error}));
    }
}, 1000);

$(document).ready(() => {
    import(/* webpackPrefetch: true */ 'highlight.js/styles/idea.css');
    import(/* webpackPrefetch: true */ 'katex/dist/katex.css');
    import(/* webpackChunkName: "mermaid-renderer" */ "mermaid").then(module => {
        const mermaid = module.default;

        mermaid.initialize({startOnLoad: true});
        mermaid.contentLoaded();
        document.querySelectorAll('.markdown-body .image.mermaid svg').forEach(image => image.replaceWith(imageWrapper(image)));
    });

    document.querySelectorAll(
        '.markdown-body img:not([class]), .markdown-body svg').forEach(image => image.replaceWith(imageWrapper(image)));

    document.querySelectorAll('.markdown-body .code-block').forEach(codeBlock => {
        const codeCopy = createCodeCopy();
        if (!codeBlock.querySelector('.ui.right.attached.label')) {
            codeBlock.addEventListener('mouseover',
                () => codeBlock.insertAdjacentElement('beforeend', codeCopy));
        }
        codeBlock.addEventListener('mouseleave',
            () => codeBlock.removeChild(codeCopy));
    });

    document.querySelectorAll('.markdown-body textarea.rich-text').forEach(richTextTextArea => richTextTextArea.replaceWith(createEditor(richTextTextArea)));

    document.querySelectorAll('.ui.label.attachment').forEach(attachment => {
        const title = attachment.getAttribute('title') || '';
        const content = friendlyBytes(attachment.getAttribute('data-size'));
        $(attachment).popup({
            variation: 'mini',
            title,
            content,
        });
    });

    document.querySelectorAll('table[data-id][data-tasks]').forEach((taskListTable, tableIndex) => {
        const workflowDefinitionId = taskListTable.getAttribute('data-id');
        const workflowDefinitionVersion = taskListTable.getAttribute('data-version');
        const taskNames = parseJSON(decode(taskListTable.getAttribute('data-tasks')));
        const filterJsonPath = parseJSON(decode(taskListTable.getAttribute('data-filter')));
        const defaultSort = parseJSON(decode(taskListTable.getAttribute('data-sort')));
        const defaultDesc = taskListTable.getAttribute('data-desc') === '1';
        const pageSize = taskListTable.getAttribute('data-size');
        const tableWidth = taskListTable.getAttribute('data-width');

        const tableRows = [];
        let foundDataRow = -1;
        const taskListBody = taskListTable.querySelector('tbody');
        taskListBody.querySelectorAll('tr').forEach((tableRow, rowIndex) => {
            if (foundDataRow < 0 && tableRow.hasAttribute('data-workflow-id') && tableRow.hasAttribute('data-task-id')) {
                foundDataRow = rowIndex;
            }

            if (foundDataRow < 0) {
                tableRow.classList.remove('hidden');
            } else {
                const clonedRow = tableRow.cloneNode(true);
                clonedRow.classList.remove('hidden');
                tableRows.push(clonedRow.outerHTML);
            }
        });

        if (!isEmpty(tableRows)) {
            taskListBody.querySelectorAll("tr th a[href*='sort=']").forEach(sortLink => {
                sortLink.classList.add('sortable');
                const urlSearchParams = new URLSearchParams(sortLink.getAttribute('href'));
                urlSearchParams.set('wdf', workflowDefinitionId);

                if (!isEmpty(workflowDefinitionVersion)) {
                    urlSearchParams.set('wdfv', workflowDefinitionVersion);
                }

                let tableSortDesc = urlSearchParams.has('desc');
                if (tableSortDesc || defaultDesc) {
                    urlSearchParams.delete('desc');
                } else {
                    urlSearchParams.set('desc', '1');
                }

                sortLink.addEventListener('click', event => {
                    event.preventDefault();
                    document.getElementById('table-sortable-order')?.remove();

                    tableSortDesc = urlSearchParams.has('desc');

                    history.pushState(null, '', `${window.location.pathname}?${urlSearchParams.toString()}`);

                    if (tableSortDesc) {
                        urlSearchParams.delete('desc');
                    } else {
                        urlSearchParams.set('desc', '1');
                    }
                    sortLink.href = `${window.location.pathname}?${urlSearchParams.toString()}`;

                    sortLink.insertAdjacentHTML('beforeend', `<img id='table-sortable-order' class="icon-14 ui icon" data-variation="mini" data-tooltip="${tableSortDesc ? 'Sorted descending' : 'Sorted ascending'}" src="${tableSortDesc ? ArrowDownSvg : ArrowUpSvg}" alt=""/>`);

                    createTableContent();
                });

                const pageSearchParams = new URLSearchParams(window.location.search);
                const pageWorkflowDefinitionId = pageSearchParams.get('wdf') || workflowDefinitionId;
                const pageSort = pageSearchParams.get('sort') || defaultSort;
                const pageDesc = pageSearchParams.has('desc') || defaultDesc;

                if (pageWorkflowDefinitionId === workflowDefinitionId && pageSort === urlSearchParams.get('sort')) {
                    sortLink.href = `${window.location.pathname}?${urlSearchParams.toString()}`;
                    sortLink.insertAdjacentHTML('beforeend', `<img id='table-sortable-order' class="icon-14 ui icon" src="${pageDesc ? ArrowDownSvg : ArrowUpSvg}" alt=""/>`);
                }
            });

            const refreshButtonId = `data-table-${tableIndex}-refresh`;
            taskListTable.insertAdjacentHTML('beforeend', `<tfoot class="full-width"><tr><th colSpan="${tableWidth}" class="right aligned">
          <div class="ui buttons basic tiny left floated"><button id="${refreshButtonId}" class="ui button">Refresh</button></div>
          <div class="ui icon buttons basic tiny paging">
          <div id="${workflowDefinitionId}-first-page" class="ui button disabled"><i class="angle double left icon"></i></div>
          <div id="${workflowDefinitionId}-previous-page" class="ui button disabled"><i class="angle left icon"></i></div>
          <div id="${workflowDefinitionId}-next-page" class="ui button disabled"><i class="angle right icon"></i></div> 
          </div>
          </th></tr></tfoot>`);

            document.getElementById(refreshButtonId).addEventListener('click', event => {
                event.preventDefault();
                createTableContent();
            });

            api(`/api/workflow-definitions/${workflowDefinitionId}/enabled`, {
                method: 'GET'
            }).then(() => {
                const pageRedirectParams = new URLSearchParams();

                if (!isEmpty(workflowDefinitionVersion)) {
                    pageRedirectParams.set('version', workflowDefinitionVersion);
                }

                pageRedirectParams.set('page', currentPageId);

                const pageSearchParams = new URLSearchParams(window.location.search);
                const pageWorkflowDefinitionId = pageSearchParams.get('wdf');
                const sort = pageWorkflowDefinitionId === workflowDefinitionId ? pageSearchParams.get('sort') : null;
                const desc = pageWorkflowDefinitionId === workflowDefinitionId ? pageSearchParams.has('desc') : null;

                if (sort) {
                    pageRedirectParams.set('sort', sort);
                }

                if (desc) {
                    pageRedirectParams.set('desc', '1');
                }

                document.getElementById(refreshButtonId).insertAdjacentHTML('beforebegin',
                    `<a class="ui button primary basic" href="/workflow-definitions/${workflowDefinitionId}/start?${pageRedirectParams.toString()}">Create</a> `);
            }).catch(error => LOGGER.debug(`Unable to confirm if ${workflowDefinitionId} enabled`, error));

            let tableLoader;
            const createTableContent = (previousCursor, nextCursor) => {
                taskListBody.querySelectorAll('tr').forEach((tableRow, rowIndex) => {
                    if (rowIndex >= foundDataRow) {
                        tableRow.remove();
                    }
                });
                tableLoader?.remove();

                const pageSearchParams = new URLSearchParams(window.location.search);
                const pageWorkflowDefinitionId = pageSearchParams.get('wdf');
                const sort = pageWorkflowDefinitionId === workflowDefinitionId ? pageSearchParams.get('sort') : null;
                const desc = pageWorkflowDefinitionId === workflowDefinitionId ? pageSearchParams.has('desc') : null;

                const taskLoaderCell = document.createElement('td');
                taskLoaderCell.colSpan = tableWidth ? Number(tableWidth) : null;
                taskLoaderCell.innerHTML = '<div class="ui active centered inline loader"></div>';

                tableLoader = document.createElement('tr');
                tableLoader.appendChild(taskLoaderCell);
                taskListBody.appendChild(tableLoader);

                api(`/api/workflow-definitions/${workflowDefinitionId}/tasks`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: stringifyJSON({
                        version: isEmpty(workflowDefinitionVersion) ? null : workflowDefinitionVersion,
                        taskNames,
                        filterJsonPath,
                        taskTemplate: tableRows.join(''),
                        page: currentPageId,
                        sort: isEmpty(sort) ? defaultSort : sort,
                        desc: desc == null ? defaultDesc : desc,
                        size: Number(pageSize) || null,
                        previousCursor,
                        nextCursor
                    })
                }).then(({content: taskList, previous: previousCursor, next: nextCursor}) => {
                    tableLoader?.remove();

                    if (!isEmpty(taskList)) {
                        taskListBody.insertAdjacentHTML('beforeend', taskList.join(''));
                        setupDropdowns(taskListBody);
                        $(taskListBody.querySelectorAll('.ui.calendar')).calendar({
                            today: true
                        });
                        taskListBody.querySelectorAll('tr[data-workflow-id][data-task-id]').forEach(row => {
                            const $form = $(row).form({
                                on: 'change',
                                autoCheckRequired: true,
                                duration: 0,
                                onValid: function () {
                                    updateTask($form, row);
                                }
                            });
                        })
                    } else {
                        taskListBody.insertAdjacentHTML('beforeend', `<tr><td${tableWidth ? ` colSpan="${tableWidth}"` : ''}>You don't have any tasks.</td></tr>`);
                    }

                    const footer = taskListTable.querySelector('tfoot th');
                    footer.querySelector('.paging')?.remove();
                    footer.insertAdjacentHTML('beforeend', `
          <div class="ui icon buttons basic tiny paging">
${!isEmpty(previousCursor) ? `<div id="${workflowDefinitionId}-first-page" class="ui button"><i class="angle double left icon"></i></div><div id="${workflowDefinitionId}-previous-page" class="ui button"><i class="angle left icon"></i></div>` : `<div id="${workflowDefinitionId}-first-page" class="ui button disabled"><i class="angle double left icon"></i></div><div id="${workflowDefinitionId}-previous-page" class="ui button disabled"><i class="angle left icon"></i></div>`}
${!isEmpty(nextCursor) ? `<div id="${workflowDefinitionId}-next-page" class="ui button"><i class="angle right icon"></i></div>` : `<div id="${workflowDefinitionId}-next-page" class="ui button disabled"><i class="angle right icon"></i></div>`} 
          </div>
        `);
                    document.getElementById(`${workflowDefinitionId}-first-page`)?.addEventListener('click', () => createTableContent());
                    document.getElementById(`${workflowDefinitionId}-previous-page`)?.addEventListener('click', () => createTableContent(previousCursor, null));
                    document.getElementById(`${workflowDefinitionId}-next-page`)?.addEventListener('click', () => createTableContent(previousCursor, nextCursor));
                }).catch(() => {
                    taskLoaderCell.className = 'ui text error';
                    taskLoaderCell.innerHTML = 'Error loading workflow tasks. ';

                    const refreshLink = document.createElement('a');

                    pageSearchParams.set('wdf', workflowDefinitionId);

                    refreshLink.href = `${window.location.pathname}?${pageSearchParams.toString()}`
                    refreshLink.textContent = 'Please try again';
                    refreshLink.href = '#';
                    refreshLink.addEventListener('click', event => {
                        event.preventDefault();
                        event.stopPropagation();
                        createTableContent();
                    });

                    taskLoaderCell.appendChild(refreshLink);
                    taskLoaderCell.appendChild(document.createTextNode('.'));
                });
            }

            createTableContent();
        }
    });

    const cardIndexFieldName = 'swf:cardIndex';
    const grids = document.querySelectorAll('div.ui.grid');
    grids.forEach((grid, gridIndex) => {
        grid.querySelectorAll('div.column[data-id][data-tasks]').forEach((taskListColumn, columnIndex) => {
            const workflowDefinitionId = taskListColumn.getAttribute('data-id');
            const workflowDefinitionVersion = taskListColumn.getAttribute('data-version');
            const color = taskListColumn.getAttribute('data-color');
            const taskNames = parseJSON(decode(taskListColumn.getAttribute('data-tasks')));
            const filterJsonPath = parseJSON(decode(taskListColumn.getAttribute('data-filter')));
            const inputParameters = parseJSON(decode(taskListColumn.getAttribute('data-input-parameters')));
            const pageSize = taskListColumn.getAttribute('data-size');

            const cards = [];
            let foundDataCard = -1;
            taskListColumn.querySelectorAll('.ui.card').forEach((card, cardIndex) => {
                if (foundDataCard < 0 && card.hasAttribute('data-workflow-id') && card.hasAttribute('data-task-id')) {
                    foundDataCard = cardIndex;
                }

                if (foundDataCard < 0) {
                    card.classList.remove('hidden');
                } else {
                    const clonedCard = card.cloneNode(true);
                    clonedCard.classList.remove('hidden');
                    cards.push(clonedCard.outerHTML);
                }
            });

            if (!isEmpty(cards)) {
                const refreshButtonId = `data-grid-${columnIndex}-refresh`;
                taskListColumn.insertAdjacentHTML('beforeend',
                    `<div class="ui buttons compact mini fluid"><button id="${refreshButtonId}" class="ui button basic">Refresh</button></div>`);

                document.getElementById(refreshButtonId).addEventListener('click', event => {
                    event.preventDefault();
                    createGridColumnContent();
                });

                api(`/api/workflow-definitions/${workflowDefinitionId}/enabled${isEmpty(workflowDefinitionVersion) ? '' : `?version=${workflowDefinitionVersion}`}`, {
                    method: 'GET'
                }).then(() => {
                    const pageRedirectParams = new URLSearchParams(inputParameters);
                    Object.keys(inputParameters).forEach(name => {
                        const value = inputParameters[name];

                        if (!isEmpty(name) && !isEmpty(value) && value instanceof Object) {
                            pageRedirectParams.set(name, stringifyJSON(value));
                        }
                    });

                    if (!isEmpty(workflowDefinitionVersion)) {
                        pageRedirectParams.set('version', workflowDefinitionVersion);
                    }

                    pageRedirectParams.set('page', currentPageId);

                    document.getElementById(refreshButtonId).insertAdjacentHTML('beforebegin',
                        `<a class="ui button primary basic" href="/workflow-definitions/${workflowDefinitionId}/start?${pageRedirectParams.toString()}">Create</a> `);
                }).catch(error => LOGGER.debug(`Unable to confirm if ${workflowDefinitionId} enabled`, error));

                let taskCountCell;
                let taskLoaderCell;
                const createGridColumnContent = () => {
                    taskListColumn.querySelectorAll('.ui.card').forEach((card, cardIndex) => {
                        if (cardIndex >= foundDataCard) {
                            card.remove();
                        }
                    });
                    taskLoaderCell?.remove();
                    taskCountCell?.remove();

                    taskLoaderCell = document.createElement('div');
                    taskLoaderCell.className = 'ui basic fitted segment';
                    taskLoaderCell.innerHTML = '<div class="ui active centered inline loader"></div>';

                    taskListColumn.appendChild(taskLoaderCell);

                    api(`/api/workflow-definitions/${workflowDefinitionId}/tasks`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: stringifyJSON({
                            version: isEmpty(workflowDefinitionVersion) ? null : workflowDefinitionVersion,
                            taskNames,
                            filterJsonPath,
                            taskTemplate: cards.join(''),
                            page: currentPageId,
                            sort: cardIndexFieldName,
                            size: Number(pageSize) || null
                        })
                    }).then(({content: taskList, next: nextCursor}) => {
                        taskLoaderCell.remove();

                        let taskCount = 0;

                        if (!isEmpty(taskList)) {
                            taskListColumn.insertAdjacentHTML('beforeend', taskList.join(''));
                            taskCount = taskList?.length || 0;
                        }

                        taskCountCell = document.createElement('div');
                        taskCountCell.className = `left aligned floating ui circular label${color ? ` ${color}` : ''}`;
                        taskCountCell.textContent = `${taskCount}`;
                        taskListColumn.insertAdjacentElement('afterbegin', taskCountCell);

                        new Sortable(taskListColumn, {
                            group: `tasks-${gridIndex}`,
                            dataIdAttr: 'data-task-id',
                            draggable: '.draggable',
                            chosenClass: 'chosen',
                            ghostClass: 'ghost',
                            direction: 'vertical',
                            fallbackOnBody: true,
                            store: {
                                set: function (sortable) {
                                    sortable.toArray().forEach((taskId, index) => {
                                        const task = taskListColumn.querySelector(`.ui.card[data-task-id='${taskId}']`);
                                        const workflowId = task.getAttribute('data-workflow-id');
                                        api(`/api/workflows/${workflowId}/tasks/${taskId}/input`, {
                                            method: 'PATCH',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            }, body: stringifyJSON({
                                                [cardIndexFieldName]: index
                                            })
                                        });
                                    });
                                }
                            },
                            onAdd: function (evt) {
                                const columnInputParameters = parseJSON(decode(evt.to.getAttribute('data-input-parameters')));
                                if (!isEmpty(columnInputParameters)) {
                                    const workflowId = evt.item.getAttribute('data-workflow-id');
                                    const taskId = evt.item.getAttribute('data-task-id');
                                    api(`/api/workflows/${workflowId}/tasks/${taskId}/input`, {
                                        method: 'PATCH',
                                        headers: {
                                            'Content-Type': 'application/json'
                                        }, body: stringifyJSON(columnInputParameters)
                                    });
                                }
                            },
                        });
                    }).catch(() => {
                        const errorMessage = document.createElement('div');
                        errorMessage.className = 'ui center aligned message error visible';
                        errorMessage.innerHTML = 'Error loading workflow tasks. ';

                        const refreshLink = document.createElement('a');
                        refreshLink.textContent = 'Please try again';
                        refreshLink.href = '#';
                        refreshLink.addEventListener('click', event => {
                            event.preventDefault();
                            event.stopPropagation();
                            createGridColumnContent();
                        });

                        errorMessage.appendChild(refreshLink);
                        errorMessage.appendChild(document.createTextNode('.'));

                        taskListColumn.replaceChild(errorMessage, taskLoaderCell);
                        taskLoaderCell = errorMessage;
                    });
                }

                createGridColumnContent();
            }
        });
    });

    document.querySelectorAll('.markdown-body .ui.accordion').forEach(element => {
        element.querySelector('.title')?.insertAdjacentHTML('afterbegin', '<i class="dropdown icon expand"></i>');
        $(element).accordion({
            selector: {
                trigger: '.title .expand'
            },
            duration: 0,
            animateChildren: false,
        });
    });
});